<div class="power">
  <enauka-simple-header></enauka-simple-header>
  <section class="container logowanie">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12 ">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h2>Weryfikacja logowania przez USOS!</h2>
            </div>
            <div class="panel-body">
              Witaj!
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
